import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const Html5Redirect = () => {
	const history = useHistory();

	useEffect(() => {
		fetch("https://levelsharesquare.com/html5/index.html", {
			method: "HEAD",
			credentials: "include",
		})
			.then((res) => {
				if (res.ok) {
					// Static page exists — redirect browser to it
					window.location.href = "/html5/";
				} else {
					// Doesn't exist — redirect within React app
					history.replace("/pagenotfound");
				}
			})
			.catch(() => {
				// Network error or something else failed
				history.replace("/pagenotfound");
			});
	}, [history]);

	return <p>Redirecting...</p>;
};

export default Html5Redirect;
